import React from 'react';
// @ts-ignore
import styles from './ManagerSettingsTableItem.module.scss';
import Text from '../../../../../../Components/Base/Text/Text';

interface Props {
	label: string;
	children: React.ReactNode;
}

const ManagerSettingsTableItem: React.FC<Props> = ({ label, children }) => {
	return (
		<tr className={styles.wrapper}>
			<td>
				<Text tx={label} className={styles.title} />
			</td>
			<td>{children}</td>
		</tr>
	);
};

export default ManagerSettingsTableItem;
